// Add facebook link to instagram feed
var a = document.createElement('a');
a.className = 'button';
a.setAttribute('href', 'https://www.facebook.com/moderaternanykoping');
a.innerHTML = 'Besök oss på Facebook';
// apend the anchor to the body
// of course you can append it almost to any other dom element
if(document.querySelector('#sbi_load')) {
    document.querySelector('#sbi_load').appendChild(a);
}
//# sourceMappingURL=footer-instagram.js.map
